import { IState } from 'modules/IP-location/IP-location.reducer';

const LOCATION_MOCK = {
    ip: '92.249.69.5',
    countryName: 'Ukraine',
    countryCode: 'UA',
    regionName: 'Kyiv City',
    regionCode: '30',
    city: 'Kyiv',
    zipCode: '03087',
    timeZone: 'Europe/Kiev',
    latitude: '50.4333',
    longitude: '30.5167',
    isp: 'Private Stock company Sater',
    organization: 'Private Stock company Sater'
};

export const IPLocation = (): IState => {
    return { data: LOCATION_MOCK, error: null };
};

export default IPLocation;
